import updateMe from "./update-me.js";
import getMe from "./get-me.js";
import sendResetPassword from "./send-reset-password.js";
import verifyResetPassword from "./verify-reset-password.js";
import resetPassword from "./reset-password.js";

export default {
	updateMe,
	getMe,
	sendResetPassword,
	verifyResetPassword,
	resetPassword,
};
